module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "navbar",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('hamburger', {
    staticClass: "hamburger-container",
    attrs: {
      "toggleClick": _vm.toggleSideBar,
      "isActive": _vm.sidebar.opened
    }
  }), _vm._v(" "), _c('levelbar'), _vm._v(" "), _c('tabs-view'), _vm._v(" "), (_vm.log.length > 0) ? _c('error-log', {
    staticClass: "errLog-container",
    attrs: {
      "logsList": _vm.log
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container",
    attrs: {
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": (_vm.avatar ? _vm.avatar : _vm.defaultAvatar)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "user-name"
  }, [_vm._v(" " + _vm._s(_vm.name) + " ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "user-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('router-link', {
    staticClass: "inlineBlock",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.changePwd
    }
  }, [_vm._v("修改密码")])]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22907900"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Navbar.vue
// module id = 287
// module chunks = 25